<template>
  <div class="xb-order" id="xbOrder">
    <p class="desc">订货单</p>
    <div class="filter-order-condition">
      <el-select class="order-classify" v-model="orderStatus" clearable placeholder="请选择">
        <el-option
          v-for="(type, index) in orderStatusList"
          :key="index"
          :label="type.label"
          :value="type.value"
        ></el-option>
      </el-select>
      <el-input class="gray" v-model="orderSearchKey" placeholder="商品名称/订单号"></el-input>
      <el-button class="btn-red" @click="filterOrder">筛选</el-button>
    </div>
    <div class="order-list-container">
      <ul class="columns">
        <li class="long order-detail">订单详情</li>
        <li class="short order-receiver">收货人</li>
        <li class="short total-amount">总金额</li>
        <li class="short order-status">订单状态</li>
        <li class="short pay-status">付款状态</li>
        <li class="short operations">操作</li>
      </ul>
      <ul v-show="orderList.length" class="order-list">
        <li class="order" v-for="(order, index) in orderList" :key="index">
          <div class="time-ordernum">
            <span class="time">{{order.createTime}}</span>
            <div class="order-num">
              订单编号：
              <span class="package-tip" v-if="order.isPackage">套餐</span>
              <span class="num">{{order.orderCode}}</span>
              <img v-show="order.isSelect == 1?true:false" src="../../../../assets/personal/sample.png">
            </div>
          </div>
          <div :class="order.isMore?'order-content':'order-content maxH240'">
            <div class="order-detail long" :class="order.goodList.length == 1?'active':''">
              <div v-for="(good, index) in order.goodList" :key="index" class="commodity-detail">
                <img
                  v-if="good.img"
                  class="commodity-img"
                  width="60"
                  height="60"
                  :src="good.img"
                  alt="商品图"
                  @click="goToProduct(good.id)"
                />
                <img
                  v-else
                  class="commodity-img"
                  width="60"
                  height="60"
                  src="http://image.8844it.com/ydb2/goodDefault.png"
                  alt="商品图"
                  @click="goToProduct(good.id)"
                />
                <div class="name-norm">
                  <span class="name" :title="good.info" @click="goToProduct(good.id)">{{good.info}}</span>
                  <span class="norm">{{good.norm}}</span>
                </div>
                <span class="unit-price">￥{{good.price}}</span>
                <span class="amount">X{{good.amount}}</span>
              </div>
            </div>
            <div class="order-receiver short">{{order.reveiver}}</div>
            <div class="total-amount short">
              <span class="amount">￥{{order.total}}</span>
              <span class="freight">（包含运费：{{order.freight}}）</span>
            </div>
            <div class="order-status short">
              <span class="status">{{order.orderStatusValue}}</span>
            </div>
            <div class="pay-status short">{{order.paymentStatusValue}}</div>
            <div class="operations short">
              <div class="btns-container">
                <div class="btns-container-main" v-show="order.canPay||order.canCancel||order.paymentStatus === 1">
                  <el-button v-show="order.canPay" class="btn-red" @click="toPay(order)">去支付</el-button>
                  <span v-show="order.canCancel" class="cancel-btn" @click="toCancelOrder(order.orderCode)">取消订单</span>
                  <span v-show="order.orderStatus === 8" class="confirm-btn" @click="toConfirmReceive(order.orderCode)">确认收货</span>
                  <span
                    class="return-btn"
                    v-show="order.ableReturn&&order.orderStatus === 9"
                    @click="toReturnOrder(order.orderCode)"
                  >发起退货</span>
                </div>
                <span class="more-order" @click="moreOrder(order.orderCode)">再来一单</span>
                <span v-if="order.paymentStatus === 1 && order.orderStatus === 11" class="more-order" @click="confirmCollection(order.orderCode)">确认收款</span>
                <span class="detail-btn" @click="toOrderDetail(order.orderCode)">订单详情</span>
              </div>
            </div>
          </div>
          <div v-if="order.goodList.length>3" class="more" @click="moreGoods(index)">
            <p v-show="!order.isMore" class="more-btn">
              <span>展开</span>
              <svg viewBox="0 0 1024 1024" version="1.1" p-id="2731" width="12" height="12">
                <path
                  d="M507.584 736.064a32.896 32.896 0 0 1-23.36-9.664L110.912 353.088a33.024 33.024 0 0 1 46.72-46.656L530.944 679.68a33.024 33.024 0 0 1-23.36 56.384"
                  p-id="2732"
                  fill="#999999"
                />
                <path
                  d="M507.584 736.064a32.896 32.896 0 0 1-23.36-56.32l382.144-382.08a33.024 33.024 0 0 1 46.656 46.656L531.008 726.4a33.152 33.152 0 0 1-23.424 9.664"
                  p-id="2733"
                  fill="#999999"
                />
              </svg>
            </p>
            <p v-show="order.isMore" class="more-btn">
              <span>收起</span>
              <svg viewBox="0 0 1024 1024" version="1.1" p-id="3107" width="12" height="12">
                <path
                  d="M516.41600001 287.936a32.896 32.896 0 0 1 23.35999999 9.664L913.088 670.912a33.024 33.024 0 0 1-46.72 46.656l-373.312-373.248a33.024 33.024 0 0 1 23.36000001-56.384"
                  fill="#999999"
                  p-id="3108"
                />
                <path
                  d="M516.41600001 287.936a32.896 32.896 0 0 1 23.35999999 56.32l-382.144 382.08a33.024 33.024 0 0 1-46.656-46.656l382.016-382.08a33.152 33.152 0 0 1 23.42400001-9.664"
                  fill="#999999"
                  p-id="3109"
                />
              </svg>
            </p>
          </div>
        </li>
      </ul>
      <div class="tip" v-show="!orderList.length">暂无数据</div>
      <div class="pagination-tpl-container">
        <pagination-tpl :total="orderListTotal" @queryChange="onQueryChange"></pagination-tpl>
      </div>
    </div>
    <!-- 取消订单弹框 -->
    <Dialog
      title="取消订单"
      content="是否取消订单"
      :dialogVisible="showCancelOrderDialog"
      @confirm="cancelOrder"
      @cancel="notCancelOrder"
      @hide="toHideCancelOrderDialog"
    ></Dialog>
  </div>
</template>

<script >
import Dialog from "base/xb-base/Dialog";
import PaginationTpl from "base/PaginationTpl";
import { formaTimeToSecond } from "common/js/util.js";
import XbOrder from "models/xb/order.js";
const xbOrder = new XbOrder();
const orderStatusList = [
  {
    label: "待付款",
    value: 0,
  },
  {
    label: "待审核",
    value: 1,
  },
  {
    label: "待发货",
    value: 7,
  },
  {
    label: "待收货",
    value: 8,
  },
  {
    label: "已完成",
    value: 9,
  },
  {
    label: "已取消",
    value: 10,
  },
  {
    label: "待确认收款",
    value: 11,
  },
];
export default {
  data() {
    return {
      // 是否显示取消订单操作弹框
      showCancelOrderDialog: false,
      // 初始化当前页面
      currentPage: 1,
      // 订单筛选--关键字
      orderSearchKey: "",
      // 订单筛选--订单状态
      orderStatus: "",
      // 订单类型
      orderStatusList: orderStatusList,
      // 订单总数
      orderListTotal: 0,
      orderList: [],
      // 无参数筛选
      searchWithNoParam: true,
      // 上次筛选条件
      options: {
        status: "",
        searchValue: "",
      },
      // 弹框时被选中的orderCode
      currOrderCode: "",
    };
  },
  methods: {
    // 订单翻页
    onQueryChange(query) {
      if (this.searchWithNoParam) {
        // 无参数查询
        let options = {
          status: "",
          searchValue: "",
          currentPage: query.currentPage,
        };
        this._getXBOrderList(options);
      } else {
        let options = Object.assign(this.options, query);
        this._getXBOrderList(options);
      }
    },
    moreGoods(index) {
      let isMore = !this.orderList[index].isMore;
      console.log(isMore);
      // this.orderList[index].isMore = isMore;
      this.$set(this.orderList[index], "isMore", isMore);
    },
    // 筛选订单
    filterOrder() {
      // 将currentPage重新赋值为1
      this.currentPage = 1;
      this.searchWithNoParam = false;
      // 将筛选条件记录起来
      this.options = {
        status: this.orderStatus,
        searchValue: this.orderSearchKey,
      };
      let options = Object.assign(this.options, {
        currentPage: this.currentPage,
      });
      this._getXBOrderList(options);
    },
    // 去支付
    toPay(order) {
      // 跳转路由
      this.$router.push({
        path: "/confirm-pay",
        query: {
          orderPreCode: order.orderCode,
        },
      });
    },
    // 订单详情
    toOrderDetail(orderCode) {
      let routeUrl = this.$router.resolve({
        path: "/personal/xb-order-detail",
        query: {
          orderCode: orderCode,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 取消订单
    cancelOrder() {
      let data = {
        orderCode: this.currOrderCode,
      };
      this._cancelOrderByOrderCode(data);
    },
    // 不取消订单
    notCancelOrder() {
      this.showCancelOrderDialog = false;
    },
    // 隐藏编辑框
    toHideCancelOrderDialog() {
      this.showCancelOrderDialog = false;
    },
    // 取消订单
    toCancelOrder(orderCode) {
      this.currOrderCode = orderCode;
      this.showCancelOrderDialog = true;
    },
    // 确认收货
    toConfirmReceive(orderCode) {
      let data = {
        orderCode: orderCode,
      };
      this._confirmReceiveByOrderCode(data);
    },
    // 发起退货
    toReturnOrder(orderCode) {
      this.$router.push({
        path: "/personal/xb-launch-order-return",
        query: {
          orderCode: orderCode,
        },
      });
    },
    _orderStatusToOrderStatusValue(orderStatus) {
      const statusToValueMap = {
        0: "待付款",
        1: "待审核",
        3: "已拒绝",
        4: "待审核",
        5: "待审核",
        7: "待发货",
        8: "待收货",
        9: "已完成",
        10: "已取消",
        11: "待确认收款"
      };
      return statusToValueMap[orderStatus];
    },
    _getXBOrderList(
      options = {
        currentPage: 1,
        status: "",
        searchValue: "",
      }
    ) {
      xbOrder
        .getXBOrderList(options)
        .then((res) => {
          if (res.success) {
            let { currentPage, totalNum, items } = res.result;
            this.currentPage = currentPage;
            this.orderListTotal = totalNum;
            // 先置空
            this.orderList = [];
            console.log("订单列表", items);
            items.map((item) => {
              let goodList = [];
              if (item.orderDetails) {
                item.orderDetails.map((good) => {
                  let normList = JSON.parse(good.itemTitle);
                  let norm = "";
                  for (let key in normList) {
                    norm += `,${normList[key]}`;
                  }
                  goodList.push({
                    id: good.goodsId,
                    img: good.goodsPic,
                    info: good.goodsName,
                    // 商品规格
                    norm: norm.substring(1),
                    // 单个商品价格
                    price: good.unitPrice,
                    // 单个商品数量
                    amount: good.quantity,
                    // 单个商品小计
                    subtotal: good.subtotal,
                  });
                });
                item.tempOrderDetailList.map((good) => {
                  goodList.push({
                    id: good.goodsId,
                    img: good.goodsPic,
                    info: good.goodsName,
                    // 商品规格
                    norm: good.itemTitle,
                    // 单个商品价格
                    price: good.unitPrice,
                    // 单个商品数量
                    amount: good.quantity,
                    // 单个商品小计
                    subtotal: good.subtotal,
                  });
                });
              }
              this.orderList.push({
                id: item.order.id,
                canCancel: item.canCancel,
                canPay: item.canPay,
                isMore: false,
                // 是否为套餐
                isPackage: Boolean(item.order.setMealId),
                // 能否退货
                ableReturn: item.order.canRefund,
                createTime: formaTimeToSecond(item.order.createTime),
                orderCode: item.order.orderCode,
                isSelect: item.order.isSelect,
                reveiver: item.order.receivedName,
                // 实付金额
                total: item.order.paymentPrice,
                freight: item.order.freight,
                orderType: item.order.orderType,
                orderStatus: item.order.status,
                orderStatusValue: this._orderStatusToOrderStatusValue(
                  item.order.status
                ),
                paymentStatus: item.order.paymentStatus,
                paymentStatusValue:
                  item.order.paymentStatus === 0
                    ? "待支付"
                    : item.order.paymentStatus === 1
                    ? "已支付"
                    : "已关闭",
                goodList: goodList,
              });
            });
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((e) => {
          console.log("获取订单异常--", e);
        });
    },
    _cancelOrderByOrderCode(data) {
      xbOrder
        .cancelOrderByOrderCode(data)
        .then((res) => {
          if (res.success) {
            // 重新获取订单
            this._getXBOrderList();
            this.$message({
              message: "操作成功",
              center: true,
              type: "success",
              duration: 1000,
            });
            this.showCancelOrderDialog = false;
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
            this.showCancelOrderDialog = false;
          }
        })
        .catch((e) => {
          console.log("取消订单异常--", e);
        });
    },
    _confirmReceiveByOrderCode(data) {
      xbOrder
        .confirmReceiveByOrderCode(data)
        .then((res) => {
          if (res.success) {
            // 重新获取订单
            this._getXBOrderList();
            this.$message({
              message: "操作成功",
              center: true,
              type: "success",
              duration: 1000,
            });
          } else {
            this.$message({
              message: res.message,
              center: true,
              type: "error",
              duration: 1000,
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: "操作失败",
            center: true,
            type: "error",
            duration: 1000,
          });
        });
    },
    // 前往商品详情页
    goToProduct(id) {
      if (id !== 0) {
        let routeUrl = this.$router.resolve({
          path: "/product",
          query: {
            id: id,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 再来一单
    moreOrder(v) {
      let orderCode = v
      let data = {
        orderCode
      }
      xbOrder.postMoreOrder(data).then(res => {
        if (res.success) {
          let shopCartIds = res.result
          this.$router.push({
            path: "/confirm-order",
            query: {
              selectedShopCartIds: JSON.stringify(shopCartIds),
              moreOrder: true
            },
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 确认收款
    confirmCollection(v) {
      let orderCode = v
      let data = {
        orderCode
      }
      xbOrder.postConfirmCollection(data).then(res => {
        if (res.success) {
          this._getXBOrderList();
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  created() {
    // 如果是从个人中心页面跳转过来的，会携带参数
    let status = this.$route.query.status;
    if (status) {
      // 如果有这个参数
      this.orderStatus = Number(status);
      this.filterOrder();
    } else {
      let initOptions = {
        currentPage: 1,
        status: "",
        searchValue: "",
      };
      this._getXBOrderList(initOptions);
    }
  },
  components: {
    PaginationTpl,
    Dialog,
  },
};
</script>

<style lang="scss" scoped>
.xb-order {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  font-size: 16px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  padding: 0 20px 30px 20px;
  .desc {
    box-sizing: border-box;
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(96, 98, 102, 1);
    border-bottom: 1px solid #e4e4e4;
  }
  .filter-order-condition {
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .order-classify {
      margin-right: 20px;
    }
    .gray {
      width: 220px;
      margin-right: 20px;
    }
    .btn-red {
      height: 32px;
      width: 80px;
      color: #fff;
      border: 0px;
      background: rgba(223, 52, 69, 0.75);
      &:hover {
        background: rgba(223, 52, 69, 1);
      }
    }
  }
  .order-list-container {
    .columns {
      height: 32px;
      background: rgba(247, 247, 247, 1);
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      font-size: 12px;
      .long {
        width: 380px;
        display: flex;
        justify-content: center;
      }
      .short {
        width: 120px;
        display: flex;
        justify-content: center;
      }
    }
    .order-list {
      .order {
        font-size: 12px;
        color: #606266;
        margin-bottom: 20px;
        .time-ordernum {
          height: 32px;
          padding-left: 20px;
          background: rgba(247, 247, 247, 1);
          border-radius: 2px 2px 0px 0px;
          border: 1px solid rgba(228, 228, 228, 1);
          display: flex;
          justify-content: flex-start;
          align-items: center;
          color: rgba(145, 147, 152, 1);
          .time {
            margin-right: 24px;
          }
          .order-num {
            .package-tip {
              background: #df3445;
              color: #fff;
            }
            .num {
              color: rgba(96, 98, 102, 1);
            }
            img {
              margin-left: 40px;
            }
          }
        }
        .order-content {
          display: flex;
          flex-direction: row;
          border: 1px solid rgba(228, 228, 228, 1);
          border-top: none;
          .long {
            width: 380px;
            border-right: 1px solid rgba(228, 228, 228, 1);
          }
          .short {
            width: 120px;
            border-right: 1px solid rgba(228, 228, 228, 1);
            &:last-child {
              border-right: none;
            }
          }
          .order-detail {
            display: flex;
            flex-direction: column;
            border-right: 1px solid rgba(228, 228, 228, 1);
            .commodity-detail {
              box-sizing: border-box;
              padding: 10px;
              height: 80px;
              display: flex;
              align-items: center;
              color: rgba(96, 98, 102, 1);
              .commodity-img {
                cursor: pointer;
              }
              .name-norm {
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 12px;
                font-size: 12px;
                .name {
                  width: 180px;
                  height: 24px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 2;
                  overflow: hidden;
                  cursor: pointer;
                }
                .name:hover {
                  color: rgba(223, 52, 69, 1);
                }
                .norm {
                  margin-top: 6px;
                  width: 124px;
                  color: #919398;
                }
              }
              .unit-price {
                margin-left: 24px;
                margin-right: 14px;
              }
            }
          }
          .active {
            justify-content: center;
          }
          .order-receiver {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .total-amount {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .freight {
              margin-top: 4px;
              color: #919398;
            }
          }
          .order-status {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .detail-btn {
              margin: 5px 0;
              color: #3d74f2;
              cursor: pointer;
            }
          }
          .pay-status {
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .operations {
            display: flex;
            justify-content: center;
            align-items: center;
            .detail-btn {
              cursor: pointer;
              margin: 5px 0;
            }
            .detail-btn:hover {
              color: rgba(223, 52, 69, 1);
            }
            .cancel-btn {
              cursor: pointer;
              margin: 5px 0;
              width: 80px;
              text-align: center;
              height: 20px;
              color: #fff;
              line-height: 20px;
              background: rgba(223, 52, 69, 0.75);
            }
            .cancel-btn:hover {
              background: rgba(223, 52, 69, 1);
            }
            .confirm-btn {
              cursor: pointer;
              margin: 5px 0;
              width: 80px;
              text-align: center;
              height: 20px;
              color: #fff;
              line-height: 20px;
              background: rgba(223, 52, 69, 0.75);
            }
            .confirm-btn:hover {
              background: rgba(223, 52, 69, 1);
            }
            .return-btn {
              cursor: pointer;
              margin: 5px 0;
              width: 80px;
              text-align: center;
              height: 20px;
              color: #fff;
              line-height: 20px;
              background: rgba(223, 52, 69, 0.75);
            }
            .return-btn:hover {
              background: rgba(223, 52, 69, 1);
            }
            .more-order {
              width: 80px;
              height: 20px;
              box-sizing: border-box;
              line-height: 18px;
              background: #fff;
              margin: 5px 0;
              font-size: 12px;
              padding: 0;
              cursor: pointer;
              text-align: center;
              color: rgba(223, 52, 69, 0.75);
              border: 1px solid rgba(223, 52, 69, 0.75);
            }
            .btns-container {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .btn-red {
                width: 80px;
                height: 20px;
                margin: 5px 0;
                color: #fff;
                background: rgba(223, 52, 69, 0.75);
                border-radius: 2px;
                font-size: 12px;
                padding: 0;
                &:hover {
                  background: rgba(223, 52, 69, 1);
                }
              }
              .btns-container-main {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              }
            }
          }
        }
        .maxH240 {
          max-height: 240px;
          overflow: hidden;
        }
        .more {
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #e4e4e4;
          border-top: 0;
          height: 24px;
          cursor: pointer;
          .more-btn {
            background: #fff;
            font-size: 11px;
            /* position: relative; */
            /* top: -1px; */
            color: #999999;
            display: flex;
            align-items: center;
            svg {
              margin-left: 3px;
            }
          }
        }
      }
    }
    .pagination-tpl-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .tip {
      border: 1px solid #e4e4e4;
      height: 80px;
      text-align: center;
      line-height: 80px;
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>

<style lang="scss">
#xbOrder {
  .el-radio-group {
    .el-radio-button {
      border: none;
      box-shadow: none;
      .el-radio-button__inner {
        font-size: 14px;
        border: none;
        padding-left: 0;
        color: #606266;
        background: #fff;
      }
      .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        box-shadow: none;
        color: #df3445;
      }
    }
  }
  .el-select {
    min-width: 120px;
    max-width: 120px;
    margin-right: 20px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      background: rgba(234, 238, 245, 0.2);
      border-radius: 4px;
      border: 1px solid rgba(234, 238, 245, 1);
      padding: 0 20px 0 8px;
      font-size: 14px;
      font-family: "PingFangSC-Regular";
      color: rgba(96, 98, 102, 1);
      letter-spacing: 1px;
      padding-left: 15px;
    }
    .el-input__suffix {
      height: 40px;
      top: -3px;
      right: 0px;
    }
    .is-focus {
      .el-input__inner {
        border: 1px solid rgba(61, 116, 242, 1);
      }
    }
  }
  .el-button:active {
    border: none;
    transform: none;
  }
}
</style>
